import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import LoginForm from "./components/Login.vue";
import DataService from "@/services/data-service/data-service";

Vue.use(Router);

const router = new Router({
  mode: process.env.IS_ELECTRON ? "hash" : "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: "/login",
      component: LoginForm
    },
    {
      path: "/rag",
      component: () => import("./views/pohi/pohi-home.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/rag/dashboard",
      component: () => import("./views/pohi/pohi-dashboard.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca",
      component: () => import("./views/msca/msca-home.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/compartment-assessments/",
      component: () =>
        import("./views/msca/compartment-assessment/CompartmentAssessmentsComponent.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/compartment-assessments/new",
      component: () =>
        import("./views/msca/compartment-assessment/NewCompartmentAssessmentComponent.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/compartment-assessments/:id",
      component: () =>
        import("./views/msca/compartment-assessment/NewCompartmentAssessmentComponent.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/compartment-assessments/:id/:showReport",
      component: () =>
        import("./views/msca/compartment-assessment/CompartmentAssessmentReportComponent.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/onePageReview/:to",
      component: () =>
        import("./views/msca/compartment-assessment/CompartmentAssessmentReportComponent.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/compartment-assessments/:id/:showReport/editable",
      component: () =>
        import(
          "./views/msca/compartment-assessment/CompartmentAssessmentEditableReportComponent.vue"
        ),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/reports/:typeRecord",
      name: "mscaReports",
      component: () => import("./views/msca/compartment-assessment/ReportChart.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/msca/maritime-standards",
      name: "maritimestandards",
      component: () => import("./views/msca/compartment-assessment/MaritimeStandards.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/admin",
      name: "admin",
      component: () => import("./views/Admin.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/log",
      name: "log",
      component: () => import("./views/admin/Log.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/ships",
      name: "adminShips",
      component: () => import("./views/admin/Ships.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/itineraries",
      name: "adminItineraries",
      component: () => import("./views/admin/Itineraries.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/ports",
      name: "adminPorts",
      component: () => import("./views/admin/Ports.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/users",
      name: "adminUsers",
      component: () => import("./views/admin/Users.vue"),
      meta: { requiresCompanyAdmin: true }
    },
    {
      path: "/admin/companies",
      component: () => import("./views/admin/Companies.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/wastetypesadmin",
      component: () => import("./views/admin/WasteTypesAdmin.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/wastetypes",
      component: () => import("./views/admin/WasteTypes.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/wastecategories",
      component: () => import("./views/admin/WasteCategories.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/measurementunits",
      component: () => import("./views/admin/MeasurementUnits.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/pooldrainoptions",
      component: () => import("./views/admin/PoolDrainOptions.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/admin/import",
      component: () => import("./views/admin/Import.vue"),
      meta: { requiresAdmin: true }
    },
    {
      path: "/epmd",
      component: () => import("./views/epmd/epmd-home.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/epmd/:disposalType",
      component: () => import("./views/epmd/epmd-submenu.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/epmd/:disposalType/reports",
      component: () => import("./views/epmd/epmd-table.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/epmd/:disposalType/add",
      component: () => import("./views/epmd/epmd-table.vue"),
      meta: { requiresAuth: true, addEPMD: true }
    },
    {
      path: "/vopAuth",
      name: "vopAuth",
      component: () => import("./views/vopAuth.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "*",
      component: LoginForm
    }
  ]
});

router.beforeEach((to, from, next) => {
  const routerUserServiceActions = (Vue.prototype.$dataService as DataService).actions.Auth;
  const routerUserServiceGetter = (Vue.prototype.$dataService as DataService).getters.Auth;
  const timeoutService = Vue.prototype.$dataService.actions.TimeOut;
  timeoutService.reset();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const userInfo = routerUserServiceActions.getAuthHeader();
    if (!userInfo) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      timeoutService.start();
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresAdmin)) {
    const adminShips = routerUserServiceActions.getShipAdmin();
    const isAdmin = routerUserServiceGetter.isAdmin();
    if (!isAdmin && (!adminShips || adminShips.length === 0)) {
      next({
        path: "/"
      });
    } else {
      timeoutService.start();
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresCompanyAdmin)) {
    const isAdmin = routerUserServiceGetter.isAdmin();
    if (!isAdmin) {
      next({
        path: "/"
      });
    } else {
      timeoutService.start();
      next();
    }
  } else {
    next();
  }
});

export default router;
